var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c("div", { staticClass: "modal-dialog modal-dialog-scrollable" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(_vm._s(_vm.modalTitle)),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: { click: _vm.close },
                  },
                  [_vm._v("×")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c(
                  "form",
                  {
                    attrs: { id: "capex-item-editor-form" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.handleFormSubmit.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Name:")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          required: "",
                          minlength: "2",
                          maxlength: "100",
                        },
                        domProps: { value: _vm.name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "account" } }, [
                        _vm._v("Account:"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.accountId,
                              expression: "accountId",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { id: "account", required: "" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.accountId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("Select capex account"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.accounts, function (a) {
                            return _c("option", { domProps: { value: a.Id } }, [
                              _vm._v(_vm._s(a.Name)),
                            ])
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v("Cost (" + _vm._s(_vm.currencyLabel) + "):"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.cost,
                            expression: "cost",
                            modifiers: { number: true },
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "number",
                          required: "",
                          min: "0",
                          step: "any",
                        },
                        domProps: { value: _vm.cost },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.cost = _vm._n($event.target.value)
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Useful life (in years):")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.usefulLifeInYears,
                            expression: "usefulLifeInYears",
                            modifiers: { number: true },
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "number",
                          required: "",
                          min: "1",
                          step: "1",
                        },
                        domProps: { value: _vm.usefulLifeInYears },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.usefulLifeInYears = _vm._n($event.target.value)
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v("Capex Acquisition Month (0 = Project Start):"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.acquisitionMonthIndex,
                            expression: "acquisitionMonthIndex",
                            modifiers: { number: true },
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "number",
                          required: "",
                          min: "0",
                          step: "1",
                        },
                        domProps: { value: _vm.acquisitionMonthIndex },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.acquisitionMonthIndex = _vm._n(
                              $event.target.value
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v(
                          "Salvage value (" + _vm._s(_vm.currencyLabel) + "):"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.salvageValue,
                            expression: "salvageValue",
                            modifiers: { number: true },
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number" },
                        domProps: { value: _vm.salvageValue },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.salvageValue = _vm._n($event.target.value)
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.close },
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "submit", form: "capex-item-editor-form" },
                  },
                  [_vm._v(_vm._s(_vm.confirmButtonLabel))]
                ),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }